module.exports = __webpack_public_path__ + "img/goodsNoAct.8edc1ea9.png";